module.exports = __webpack_public_path__ + "static/img/agriculture.196d5516.jpg";